module.exports = __webpack_public_path__ + "img/oval-purple.dbb3a686.svg";